var _ = require('underscore');
var TorsoBehavior = require('backbone-torso/modules/Behavior');
var asideView = require('./asideView');

/**
 * Perspective Behavior handling aside behavior.
 *
 * @class AsideBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({
  /**
   * Updates the aside content from the details in this behavior.
   * @method updateAsideContent
   */
  updateAsideContent: function() {
    asideView.updateAsideContent({
      asideHeaderMessageKey: _.result(this, '_asideHeaderMessageKey'),
      asideContentMessageKey: _.result(this, '_asideContentMessageKey'),
      asideText: _.result(this, '_asideText'),
      showLogo: _.result(this, '_showLogo')
    });
  },

  /**
   * @method initialize
   * @param attributes {Object}
   * @param options {Object}
   *   @param options.asideHeaderMessageKey {String|Function} the message key to use for the aside's header.
   *   @param [options.asideContentMessageKey] {String|Function} the message key to use for the aside's content.
   *   @param [options.asideText] {String|Function} the text to use for the aside.  If truthy, then asideContentMessageKey is ignored.
   *   @param [options.showLogo=false] {Boolean} whether to show the logo on the aside.
   * @override
   */
  initialize: function(attributes, options) {
    _.bindAll(this, 'updateAsideContent');
    this._asideHeaderMessageKey = options.asideHeaderMessageKey;
    this._asideContentMessageKey = options.asideContentMessageKey;
    this._asideText = options.asideText;
    this._showLogo = options.showLogo;
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.view.attachView('aside', asideView, { shared: true });
  },

  /**
   * @method _attached
   * @override
   * @private
   */
  _attached: function() {
    this.updateAsideContent();
  }
});
